export default __webpack_public_path__ + "assets/images/39b9810a2ef4d32caa53289e163086d8.png";